import { useAuthentication } from '@src/authentication/useAuthentication';
import { isClientUser } from '@src/clientUser/useClientUser';
import { useTranslation } from 'react-i18next';

export const useClientLabel = () => {
  const { user } = useAuthentication();
  const { t } = useTranslation();

  return {
    clientLabel: isClientUser(user) ? t('company') : t('client'),
  };
};
